import { z } from 'zod'

export const IndustrySchema = z.object({
  id: z.number(),
  name: z.string(),
})

export const CompanySchema = z.object({
  id: z.number(),
  name: z.string(),
  url: z.url().optional(),
  establishedDate: z.date().optional(),
  capital: z.number().int().optional(),
  employeeCount: z.number().int().optional(),
  imageUrl: z.url().optional(),
  summary: z.array(z.string()).optional(),
  intro: z.any().optional(),
  industries: z.array(IndustrySchema),
  bookmarked: z.boolean(),
})

export type Company = z.input<typeof CompanySchema>

export const DEMO_COMPANY: Company = {
  id: 1,
  name: '株式会社インタレスト・テクノロジーズ',
  industries: [
    { id: 1, name: '制御・計測システム・ロボット' },
    { id: 2, name: 'AI' },
    { id: 3, name: 'ロボティクス' },
    { id: 4, name: 'IoT' },
    { id: 5, name: 'スマートファクトリー' },
  ],
  summary: [
    '産業用ロボットアームと制御システムの開発',
    '製造現場の自動化とIoT連携技術の実装',
    '次世代スマートファクトリーの実現',
  ],
  bookmarked: false,
}
